import { MuiThemeProvider } from '@material-ui/core/styles';
import Cookies from 'js-cookie';
import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import { Login, Forgot, Logout, Register } from './components/account';
import { authAxios } from './utils/AxiosHelper';

import { Route, BrowserRouter as Router } from 'react-router-dom';
import ResetPassword from './components/account/ResetPassword';
import ClinicDetails from './components/clinic/ClinicDetails';
import Table from './components/common/EntityTable';
import sorry from './components/common/sorry';
import ActivatePaitent from './components/patient/ActivatePaitent';
import PaitentsPanel from './components/patient/PaitentsPanel';
import PatientDetails from './components/patient/PatientDetails';
import PatientGoal from './components/patient/PatientGoal';
import PatientSettings from './components/patient/PatientSettings';
import PatientStatus from './components/patient/PatientStatus';
import PatientTransfers from './components/patient/PatientTransfers';
import PaitentWellcome from './components/patient/paitentWellcome';
import UserDetails from './components/user/UserDetails';
import AdminPanelclinic from './components/user/admin/AdminPanelClinic';
import './custom.css';
import { saveHistory } from './redux/actions';
import theme from './theme';
import { roles as roleObj, urls } from './utils/Objects';

function parseJwt(token) {
  if (!token) {
    return;
  }
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(window.atob(base64));
}

function findToken() {
  let axiosToken = authAxios.defaults.headers.common.Authorization;
  let cookieToken = Cookies.get('auth');
  if (axiosToken) return axiosToken.split(' ')[1];

  if (cookieToken) {
    authAxios.defaults.headers.common.Authorization = `Bearer ${cookieToken}`;
    return cookieToken;
  }
  if (!axiosToken && !cookieToken) return false;
}

function requireAuth(rt, neededPermissions = []) {
  console.log({ rt });

  console.log('requireAuth');
  let myToken = findToken();

  console.log(myToken);
  if (myToken) {
    let myRoles = parseJwt(myToken).roles;
    if (!Array.isArray(myRoles)) {
      myRoles = [myRoles];
    }

    console.log(rt.location.pathname);
    if (myRoles === null) {
      console.log('No Token');

      return false;
    }
    if (neededPermissions.length === 0) {
      console.log('All can access');
      return true;
    }

    if (neededPermissions.some((role) => myRoles.includes(role))) {
      console.log('permissaion granted ');
      return true;
    }
    return false;
  }
}



class AppContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <Router ref={(ref) => this.props.saveHistory(ref?.history)}>
          <Route exact path="/" component={Login} />
          <Route path={urls.logout} component={Logout} />
          <Route path={urls.forgot} component={Forgot} />
          <Route path={urls.register} component={Register} />
          <Route path={urls.sorry} component={sorry} />

          <Route path={urls.patientGoal} render={(rt) => (requireAuth(rt) ? <PatientGoal {...rt} /> : <Redirect to="/" />)} />
          <Route path={urls.resetPassword} render={(rt) => <ResetPassword {...rt} />} />
          <Route path={urls.users} render={(rt) => (requireAuth(rt) ? <PaitentsPanel {...rt} /> : <Redirect to="/" />)} />
          <Route path={urls.clinicUsers} render={(rt) => (requireAuth(rt) ? <PaitentsPanel {...rt} /> : <Redirect to="/" />)} />
          <Route path={urls.patients} render={(rt) => (requireAuth(rt) ? <PaitentsPanel {...rt} /> : <Redirect to="/" />)} />
          <Route path={urls.clinicPatients} render={(rt) => (requireAuth(rt) ? <PaitentsPanel {...rt} /> : <Redirect to="/" />)} />
          <Route
            path={urls.clinics}
            render={(rt) => (requireAuth(rt, [roleObj.Administrator]) ? <AdminPanelclinic {...rt} /> : <Redirect to="/" />)}
          />
          <Route
            path={urls.clinicDetails}
            render={(rt) => (requireAuth(rt, [roleObj.Administrator, roleObj.HealthCareProvider]) ? <ClinicDetails {...rt} /> : <Redirect to="/" />)}
          />
          <Route path={urls.patientDetails} render={(rt) => (requireAuth(rt) ? <PatientDetails {...rt} /> : <Redirect to="/" />)} />
          <Route path={urls.userDetails} render={(rt) => (requireAuth(rt) ? <UserDetails {...rt} /> : <Redirect to="/" />)} />
          <Route path={urls.nonClinicPaitents} render={(rt) => (requireAuth(rt) ? <PaitentsPanel {...rt} /> : <Redirect to="/" />)} />
          <Route path={urls.patientSettings} render={(rt) => (requireAuth(rt) ? <PatientSettings {...rt} /> : <Redirect to="/" />)} />
          <Route path={urls.patientTransfers} render={(rt) => (requireAuth(rt) ? <PatientTransfers {...rt} /> : <Redirect to="/" />)} />
          <Route path={urls.admins} render={(rt) => (requireAuth(rt) ? <PaitentsPanel {...rt} /> : <Redirect to="/" />)} />

          <Route path={'/table'} render={() => <Table />} />
          <Route path={urls.patientStatus} render={(rt) => (requireAuth(rt) ? <PatientStatus {...rt} /> : <Redirect to="/" />)} />
          <Route path={urls.paitentWellcome} render={(rt) => <PaitentWellcome {...rt} />} />
          <Route path={urls.activatePaitent} render={(rt) => <ActivatePaitent {...rt} />} />
        </Router>
      </MuiThemeProvider>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = {
  saveHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer);
